import { SET_DRAFT_DATA } from "../../actions/action.types";

const draftData = (state = [], action: any) => {
  if (action.type === SET_DRAFT_DATA) return action.payload;
  else return state;
};

export default draftData;
